
import moment from 'moment'

export const formatRelative = (iso) => {
    if (!iso) return ''
    const m = moment(iso)
    const diffHours = moment().diff(m, 'hours')
    if (diffHours < 24) return m.fromNow()
    if (diffHours < 48) return 'Yesterday'
    return m.format('MMM D, YYYY · HH:mm')
}

export const formatExact = (iso) => {
    if (!iso) return ''
    return moment(iso).format('MMM D, YYYY · HH:mm')
}

export const isEmailFormatValid = (email) => {
    if (!email) return false
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())
}

export const statusPillModifier = (status) => {
    switch (status) {
        case 'ASSIGNED': return 'assigned'
        case 'REJECTED': return 'rejected'
        case 'COMPLETED': return 'completed'
        default: return 'assigned'
    }
}
